import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import { Checkbox, FormControl, FormControlLabel } from '@mui/material'

function CheckboxField(props) {
  const { label, name, ...rest } = props
  return (
    <>
      <Field name={name}>
        {({ field, form, meta }) => (
          <FormControl error={meta.error && meta.touched}>
            <FormControlLabel
              {...field}
              {...rest}
              checked={field.value}
              control={<Checkbox />}
              label={label}
            />
            <ErrorMessage component={TextError} name={name} />
          </FormControl>
        )}
      </Field>
    </>
  )
}

export default CheckboxField
